const range = n => [...Array(n).keys()]

const compareSort = (a, b) =>
  a.compareNumber > b.compareNumber ? -1 : a === b ? Math.random() > 0.5 : 1

const countTotal = parties => parties.reduce((t, p) => t + p.votes, 0)

const assignEligibility = party => ({
  ...party,
  eligible: party.percentage >= 4,
})

const pickSeat = party => ({
  ...party,
  compareNumber:
    Math.round((party.votes / (1 + (party.seats + 1) * 2)) * 1000000) / 1000000,
  seats: party.seats + 1,
})

const calculateSeatPercentage = maxSeats => party => ({
  ...party,
  seatPercentage: (party.seats || 0) / maxSeats,
})

const assignSeat = (parties, maxSeats) =>
  parties
    .sort(compareSort)
    .filter(party => party.eligible)
    .map((party, i) => (!i ? pickSeat(party) : party))
    .concat(parties.filter(party => !party.eligible))
    .map(calculateSeatPercentage(maxSeats))

const assignSeats = (parties, maxSeats) =>
  range(maxSeats).reduce(parties => assignSeat(parties, maxSeats), parties)

const calculateVotes = maxVotes => party => ({
  ...party,
  votes: Math.round(maxVotes * (party.percentage / 100)),
  seats: 0,
})

const balanceRemainingVotes = maxVotes => (party, i, parties) => ({
  ...party,
  votes:
    Math.round(
      party.votes +
        (maxVotes - countTotal(parties)) *
          (party.votes / countTotal(parties)) *
          1000
    ) / 1000,
})

const calculateCompareNumbers = startDivider => party => ({
  ...party,
  compareNumber: Math.round((party.votes / startDivider) * 100) / 100,
})

export const enhanceWithSeats = (
  parties,
  maxVotes = countTotal(parties) || 1000000,
  maxSeats = 349,
  startDivider = 1.2
) => {
  /* Safeguard against numbers that are slightly larger than 100 */
  const sum = parties.reduce((previousValue, currentValue) => {
    return previousValue + currentValue.percentage
  }, 0)

  if (sum > 100) {
    const scaleFactor = 100 - (sum - 100)
    parties.forEach(p => {
      p.percentage = (p.percentage * scaleFactor) / 100
    })
  }

  /* Something is definitely wrong in raw data if number is > 105% */
  if (sum > 105) {
    alert("Warning: Problem with data calculation")
  }

  return assignSeats(
    parties
      .map(calculateVotes(maxVotes))
      .map(balanceRemainingVotes(maxVotes))
      .map(calculateCompareNumbers(startDivider))
      .map(assignEligibility),
    maxSeats
  )
}
